function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from '@signicat/designi/components/overlays';
import { Autocomplete } from '@signicat/designi/components/inputs';
import { getUsers } from "../../store/actions/users";
import t from "../../scripts/i18n";
import "../../styling/components/common/SharingSettings.css";

var SharingSettings = function SharingSettings(props) {
  var dispatch = useDispatch();
  var onClose = props.onClose,
      toUpdate = props.toUpdate,
      updateAction = props.updateAction,
      isList = props.isList;
  var currentUserId = useSelector(function (state) {
    return state.app.userId;
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      permissionList = _useState4[0],
      setPermissionList = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      usersOptions = _useState6[0],
      setUsersOptions = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedUsers = _useState8[0],
      setSelectedUsers = _useState8[1];

  var users = useSelector(function (state) {
    return state.users.data;
  });

  var handleUsersChange = function handleUsersChange(e, value) {
    setSelectedUsers(value);
  };

  var handleGrantAccess = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var payload;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              payload = _objectSpread({}, toUpdate);
              payload.permissions.users = isList ? [{
                id: currentUserId,
                accessLevel: 0
              }].concat(_toConsumableArray(selectedUsers.map(function (id) {
                return {
                  id: id,
                  accessLevel: 0
                };
              }))) : [currentUserId].concat(_toConsumableArray(selectedUsers.map(function (id) {
                return id;
              })));
              _context.prev = 3;
              _context.next = 6;
              return dispatch(updateAction(payload));

            case 6:
              onClose();
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
              console.error(_context.t0);
              setLoading(false);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 9]]);
    }));

    return function handleGrantAccess() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (permissionList && permissionList.length > 0) {
      setSelectedUsers(permissionList.map(function (u) {
        return u.userId;
      }).filter(function (id) {
        return id != currentUserId;
      }));
    }
  }, [permissionList]);
  useEffect(function () {
    if (!users || users.length <= 0) return;
    setUsersOptions(users.filter(function (u) {
      return u.userId !== currentUserId;
    }).map(function (u) {
      return {
        value: u.userId,
        text: "".concat(u.profile.firstName, " ").concat(u.profile.lastName)
      };
    }));

    if (toUpdate.permissions && toUpdate.permissions.users) {
      setPermissionList(users.filter(function (u) {
        return isList ? toUpdate.permissions.users.map(function (x) {
          return x.id;
        }).includes(u.userId) : toUpdate.permissions.users.includes(u.userId);
      }));
    }
  }, [users]);
  useEffect(function () {
    dispatch(getUsers());
  }, []);
  return /*#__PURE__*/React.createElement(Modal, {
    size: "md",
    isLoading: loading
  }, /*#__PURE__*/React.createElement("div", {
    className: "sharing-settings"
  }, /*#__PURE__*/React.createElement("h1", null, t('sharing_settings')), /*#__PURE__*/React.createElement("h2", {
    className: "separator"
  }, t('sharing_settings_who_access')), /*#__PURE__*/React.createElement("div", {
    className: "user-list"
  }, permissionList.map(function (u) {
    return /*#__PURE__*/React.createElement("div", {
      className: "separator user",
      key: u.userId
    }, /*#__PURE__*/React.createElement("div", {
      className: "information"
    }, /*#__PURE__*/React.createElement("h3", null, "".concat(u.profile.firstName, " ").concat(u.profile.lastName)), /*#__PURE__*/React.createElement("span", null, u.profile.email)), /*#__PURE__*/React.createElement("div", {
      className: "role"
    }, u.userId == currentUserId ? t('sharing_settings_is_owner') : t('sharing_settings_can_view')));
  })), /*#__PURE__*/React.createElement("div", {
    className: "invite-people"
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: true,
    options: usersOptions,
    value: selectedUsers,
    onChange: handleUsersChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, /*#__PURE__*/React.createElement("button", {
    className: "secondary",
    onClick: onClose
  }, t('sharing_settings_cancel')), /*#__PURE__*/React.createElement("button", {
    className: "primary",
    onClick: handleGrantAccess
  }, t('sharing_settings_grant_access'))))));
};

export default SharingSettings;